import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, ActivatedRoute } from '@angular/router';
import { Auth, Hub } from 'aws-amplify';
//import jwt_decode from "jwt-decode";
import { MessageService } from 'primeng/api';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
    constructor(
        private router: Router,
        private route: ActivatedRoute,
    ) { }

    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        try {
            var userInfo = await Auth.currentUserInfo();

            if (Object.keys(userInfo).length === 0) {
                console.log('something is not right with the user object, signing out');
                Auth.signOut();
                this.router.navigate(['/login']);
                return false;
            }
            
            var currentUser = await Auth.currentAuthenticatedUser({bypassCache: true});

            if (currentUser) {
                return true;
            }

            // let jwt = currentUser.signInUserSession.accessToken.jwtToken
            // let object = jwt_decode(jwt);
            // let cognitoGroups = object['cognito:groups'];

            // if (route.data.roles && route.data.roles.includes("Admin")) {
            //     if (cognitoGroups.includes("Admin")) {
            //         return true;
            //     }
            // }

            // if (route.data.roles && route.data.roles.includes("User")) {
            //     if (cognitoGroups.includes("User")) {
            //         return true;
            //     }
            // }
    
            this.router.navigate(['/access']);
            return false;
        }
        catch (ex) {
            console.log('error');
            console.log(ex.message);
            var url = window.location.href;
            this.router.navigate(['/login'], {
                queryParams: {
                  returnUrl: url
                },
                queryParamsHandling: 'merge'
              });
            
            return false;
        }
    }
}